import { Chip, Tooltip, useMediaQuery } from '@mui/material';
import { ReactNode } from 'react';

interface IntegrationStateIndicatorIconOrChipProps {
  variant: 'icon' | 'chip';
  icon: JSX.Element;
  iconTooltipTitle: string;
  chipLabel: ReactNode;
}

export const IntegrationStateIndicatorIconOrChip = ({
  variant,
  icon,
  chipLabel,
  iconTooltipTitle,
}: IntegrationStateIndicatorIconOrChipProps) => {
  const isSmallerScreen = useMediaQuery('(max-width:1200px)');

  if (variant === 'icon' || isSmallerScreen) {
    return (
      <Tooltip arrow title={iconTooltipTitle} placement="top">
        {icon}
      </Tooltip>
    );
  }

  return <Chip size="small" icon={icon} label={chipLabel} />;
};
